import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-chart-line2-icon',
  templateUrl: './shopping-chart-line2.component.html'
})
export class ShoppingChartLine2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
